module.exports = __webpack_public_path__ + "static/img/info_button2.ed843a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button2.png
// module id = ELPL
// module chunks = 4